import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the CommentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-comment',
  templateUrl: 'comment.html',
})
export class CommentPage {
  type: any;
  mydate: any
  comment = ''
  commentlen = 0
  error = false
  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController) {
    this.mydate = this.navParams.get('data')
    this.type = this.navParams.get('type')
    console.log(this.mydate)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CommentPage');
  }

  dismiss() {
    this.viewCtrl.dismiss({ success: false });
  }

  countCharacter(event) {
    this.comment = event.target.value
    this.commentlen = this.comment.length
  }

  onsubmit() {
    this.error = false
    if(this.commentlen < 1 || this.commentlen > 250) {
      this.error = true
    } else {
      this.viewCtrl.dismiss({ success: true, comment: this.comment });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/comment/comment.ts